import { render, staticRenderFns } from "./InvestorBusinessShareholderMeetingDocument.vue?vue&type=template&id=c61253ea&"
import script from "./InvestorBusinessShareholderMeetingDocument.vue?vue&type=script&lang=js&"
export * from "./InvestorBusinessShareholderMeetingDocument.vue?vue&type=script&lang=js&"
import style0 from "./InvestorBusinessShareholderMeetingDocument.vue?vue&type=style&index=0&id=c61253ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports